import { useState } from 'react';
import { Badge, Button, Text, tokens } from '@fluentui/react-components';
import { useQuery } from '@tanstack/react-query';
import { fetchRotatableSecrets, type RotatableSecret } from '../../api/admin.api';
import { RotateBotTokenDialog } from './RotateBotTokenDialog';
import { useT } from '../../i18n';

/** Lista cerrada de claves rotables (IA, bot de Campo, GitHub) con su botón "Rotar". Nunca muestra valores. */
export function SecretsRotationSection({ onRotated, highlightKey }: { onRotated: () => void; highlightKey?: string }) {
  const t = useT();
  const [selected, setSelected] = useState<RotatableSecret | null>(null);
  const { data: items = [], refetch } = useQuery({ queryKey: ['rotatable-secrets'], queryFn: fetchRotatableSecrets, retry: false });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <Text weight="semibold" style={{ fontSize: 12 }}>{t.settings.secretsTitle}</Text>
      <Text size={200} style={{ color: tokens.colorNeutralForeground3 }}>{t.settings.secretsHint}</Text>
      {items.map((it) => (
        <div key={it.key} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ flex: 1 }}>{it.label}</span>
          <Badge appearance="tint" size="small" color={it.configured ? 'success' : 'warning'}>
            {it.configured ? t.settings.secretConfigured : t.settings.secretNotConfigured}
          </Badge>
          <Button size="small" appearance={it.key === highlightKey ? 'primary' : 'subtle'} onClick={() => setSelected(it)}>
            {t.settings.rotateTokenBtn}
          </Button>
        </div>
      ))}
      <RotateBotTokenDialog secret={selected} onClose={() => setSelected(null)} onRotated={() => { refetch(); onRotated(); }} />
    </div>
  );
}
